import { Fragment, useContext, useEffect, useState } from "react";
import { GlobalContext } from "../../Context/GlobalContext";
import { axiosWithoutAuth } from "../../axios/axiosInstance";
import { toEbookRoute } from "../../Layout/Common/common";

export const SearchResultContainer = ({ search, isEbook, mainCategory }) => {
  const [eBookPath, seteBookPath] = useState(null);
  useEffect(() => {
    if (isEbook) InitLoad();
  }, [mainCategory]);

  const InitLoad = () => {
    var path = mainCategory.replace(/^\/+/, "");
    var data = {
      categoryPath: path,
    };
    axiosWithoutAuth
      .post("Category/getCategoryebookDetails", data)
      .then((response) => {
        seteBookPath(toEbookRoute(response.data.ebookLink));
      })
      .catch((error) => console.error(error.message));
  };
  const { isGridView, setIsGridView } = useContext(GlobalContext);

  return (
    <div className="row">
      <div className="col-lg-12">
        <div className="subcategory-title subcategory-pro-list">
          {isEbook ? (
            <Fragment>
              <h4>{search}</h4>{" "}
              {eBookPath != null ? (
                <div className="border-link">
                  <a href={eBookPath} target="_blank">
                    <span className="wes-ebook"></span> eBook
                  </a>
                </div>
              ) : (
                ""
              )}
            </Fragment>
          ) : (
            <Fragment>
              <h4>{`Results for '${search}'`}</h4>
              <div className="sort-filters">
                <div className="card-row">
                  <a
                    href=""
                    role="button"
                    className={`grid-products ${isGridView ? "active" : ""}`}
                    onClick={(e) => {
                      e.preventDefault();
                      setIsGridView(true);
                    }}
                  >
                    <span className="wes-card-filter" />
                  </a>
                  <a
                    href=""
                    role="button"
                    className={`row-products ${isGridView ? "" : "active"}`}
                    onClick={(e) => {
                      e.preventDefault();
                      setIsGridView(false);
                    }}
                  >
                    <span className="wes-row-filter" />
                  </a>
                </div>
              </div>
            </Fragment>
          )}
        </div>
      </div>
    </div>
  );
};
